export default {
	Home: 'Home',
	Login: 'Login',
	ChangePassword: 'ChangePassword',
	NotificationLanding: 'NotificationLanding',

	B2B_Login: 'B2B_Login',
	CompanyDetails: 'CompanyDetails',
	CompaniesList: 'CompaniesList',
	EmployeeList: 'EmployeeList',
	CompanyBudgets: 'CompanyBudgets',
	CompanyBudgetDetails: 'CompanyBudgetDetails',
	B2B_Finance: 'B2B_Finance',
	CompanyOrdersList: 'CompanyOrdersList',
	B2B_FinanceSituation: 'B2B_FinanceSituation',

	Dashboard: 'Dashboard',
	B2B_Dashboard: 'B2BDashboard',

	OrdersList: 'OrdersList',
	OrdersKanban: 'OrdersKanban',
	CreateOrder: 'CreateOrder',
	OrderDetails: 'OrderDetails',
	OrdersReviews: 'OrdersReviews',
	DiscountList: 'DiscountList',
	DiscountDetails: 'DiscountDetails',

	B2B_Kanban: 'B2B_Kanban',
	B2B_OrdersList: 'B2B_OrdersList',
	B2B_WeeklyPlan: 'B2B_WeeklyPlan',

	BusinessMenu: 'BusinessMenu',
	ToppingsList: 'ToppingsList',
	MyBusinesses: 'MyBusinesses',

	TopProducts: 'TopProducts',
	DynamicReports: 'DynamicReports',

	FinanceOverview: 'FinanceOverview',
	InvoiceDetails: 'InvoiceDetails',
	Payments: 'Payments',

	NotFoundView: 'NotFoundView',
};
